import { LInputField } from "../../../../../../../common/components/LInputField";

export const Invitees = ({ idx, setAssignState, dropInvitee, showDelete }: InviteesProps): JSX.Element => {
    return (
        <>
            {idx > 0 ? <div className="divider" /> : <></>}
            <div className="columns">
                <div className="column is-2">
                    <LInputField label="Title" inputName={`users[${idx}].title`} placeholder="" />
                </div>

                <div className="column">
                    <LInputField
                        label="First name"
                        inputName={`users[${idx}].firstName`}
                        placeholder="Enter first name"
                        onChange={setAssignState} // () => setAssignState(AssignState.ADD)}
                    />
                </div>
                <div className="column">
                    <LInputField label="Last name" inputName={`users[${idx}].lastName`} placeholder="Enter last name" />
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <LInputField label="Email" inputName={`users[${idx}].email`} placeholder="Enter email" />
                    {showDelete && (
                        <a className="is-small has-text-danger is-pulled-right is-size-7" onClick={dropInvitee}>
                            Delete user
                        </a>
                    )}
                </div>
            </div>
        </>
    );
};

interface InviteesProps {
    idx: number;
    setAssignState: () => void;
    dropInvitee: () => void;
    showDelete: boolean;
}
